var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config_switch"},[_c('div',{staticClass:"switch_tip"},[_c('h2',{domProps:{"textContent":_vm._s(_vm.title)}}),_c('p',{domProps:{"textContent":_vm._s(_vm.content)}})]),_c('div',{staticClass:"switch_main"},[_c('self-switch',{attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"change":_vm.onChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }